import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;


  .swiper-pagination .swiper-pagination-bullet {
        background: white;
    }

  .swiper-pagination .swiper-pagination-bullet-active {
        background: #FF2905;
    }

 
`;

export const SwiperContainer = styled.div`
  width: 100%;
  max-width: 1200px;  // Limita a largura máxima do carrossel
  height: 100%;
`;

export const SwiperSlideStyled = styled.div`
  text-align: center;
  font-size: 18px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;  // Altura fixa para o slide
  /* Adiciona flexbox para garantir que as imagens fiquem centralizadas verticalmente */
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Image = styled.img`
  display: block;
  width: auto;  // Deixa a largura da imagem ajustável
  max-height: 100%;  // Limita a altura máxima da imagem para caber no slide
  object-fit: contain;  // Garantir que a imagem seja redimensionada sem distorção
  max-width: 100%;  // Garantir que a largura da imagem não ultrapasse os limites do slide
`;

